import { Button, IconButton,Icon, Tooltip } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import * as RIcon from "react-icons/fa"
import CloseIcon from '@mui/icons-material/Close';

function Inpaint(props) {
  const imageInputRef = useRef(null);
  const canvasRef = useRef(null);
  const originalImageRef = useRef(null);
  const [isLassoActive, setIsLassoActive] = useState(false);
  const allLassosRef = useRef([]);
  const lassoPointsRef = useRef([]);
  const historyRef = useRef([]);
  const historyIndexRef = useRef(-1);
  const allLassosHistoryRef = useRef([]); // allLassosHistory を追加
  const isCtrlPressedRef = useRef(false);
  let inputImage = props.img || ""

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);

  const reset = () => {
    imageInputRef.current.value = ""
    canvasRef.current.width = 1
    canvasRef.current.height = 1
    originalImageRef.current = null
    setIsLassoActive(false)
    allLassosRef.current = []
    lassoPointsRef.current = []
    historyRef.current = []
    historyIndexRef.current = -1
    allLassosHistoryRef.current = []
    isCtrlPressedRef.current = false
    props.onClose()
  }

  /*const handleBase64Image = () => {
    if(img === undefined || img === null || img === "") return
    const img = new Image();
    img.src = props.img;

    img.onload = function() {
      const width = img.width;
      const height = img.height;

      const canvas = canvasRef.current;
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      // 元の画像を保存
      originalImageRef.current = ctx.getImageData(0, 0, width, height);

      // 操作履歴に追加
      addToHistory();
    }
  }*/

  useEffect(() => {
    if(inputImage !== ""){
      const img = new Image()
      img.src = inputImage

      img.onload = function() {
        const width = img.width
        const height = img.height

        const canvas = canvasRef.current
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, width, height)

        // 元の画像を保存
        originalImageRef.current = ctx.getImageData(0, 0, width, height)

        // 操作履歴に追加
        addToHistory()

        imageInputRef.current.value = ""
      };
    }
  },[inputImage])

  useEffect(() => {
    if(originalImageRef.current !== null){
      props.onChange(maskToBase64())
    }
  },[originalImageRef.current])

  const handleImage = () => {
    const file = imageInputRef.current.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = function(e) {
        const img = new Image();
        img.src = e.target.result;

        img.onload = function() {
          const width = img.width;
          const height = img.height;

          const canvas = canvasRef.current;
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          // 元の画像を保存
          originalImageRef.current = ctx.getImageData(0, 0, width, height);
          
          // 読み込み画像を設定
          props.onFileReadComplete(canvas.toDataURL())

          // 操作履歴に追加
          addToHistory();

          imageInputRef.current.value = ""
        };
      };

      reader.readAsDataURL(file);
    }
  };

  const handleMouseDown = e => {
    setIsLassoActive(true);
    lassoPointsRef.current = [];
    const point = getMousePos(e);
    lassoPointsRef.current.push(point);
  };

  const handleMouseMove = e => {
    if (!isLassoActive) return;

    const point = getMousePos(e);
    lassoPointsRef.current.push(point);

    // 描画
    drawLasso();
  };

  const handleMouseUp = () => {
    if (isLassoActive) {
      setIsLassoActive(false);

      // 白塗りを行い、元の画像を更新
      applyWhiteFill();

      // マスクを更新
      updateMask();

    }
  };

  const handleMouseLeave = () => {
    if (isLassoActive) {
      setIsLassoActive(false);

      // 白塗りを行い、元の画像を更新
      applyWhiteFill();

      // マスクを更新
      updateMask();

    }
  };

  const updateMask = () => {
    const canvas = canvasRef.current;
    const maskCanvas = document.createElement('canvas');
    maskCanvas.width = canvas.width;
    maskCanvas.height = canvas.height;
    const maskCtx = maskCanvas.getContext('2d');
    maskCtx.fillStyle = '#000';
    maskCtx.fillRect(0, 0, maskCanvas.width, maskCanvas.height);
    maskCtx.globalCompositeOperation = 'destination-out';

    for (let lasso of allLassosRef.current) {
      if (lasso.length > 0) {
        // 空でない場合のみ処理を行う
        maskCtx.beginPath();
        maskCtx.moveTo(lasso[0].x, lasso[0].y);
        for (let i = 1; i < lasso.length; i++) {
          maskCtx.lineTo(lasso[i].x, lasso[i].y);
        }
        maskCtx.closePath();
        maskCtx.fill();
      }
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Control') {
      isCtrlPressedRef.current = true;
    } else if (isCtrlPressedRef.current && e.key === 'z') {
      e.preventDefault();
      undo();
    } else if (isCtrlPressedRef.current && e.key === 'y') {
      e.preventDefault();
      redo();
    }
  };

  const handleKeyUp = e => {
    if (e.key === 'Control') {
      isCtrlPressedRef.current = false;
    }
  };

  const maskToBase64 = () => {
    // 一時キャンバスを作成
    const canvas = canvasRef.current;
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = canvas.width;
    tempCanvas.height = canvas.height;
    const tempCtx = tempCanvas.getContext('2d');

    // 一時キャンバスを黒で塗りつぶす
    tempCtx.fillStyle = '#000';
    tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

    // 白塗り履歴の現在までの状態を一時キャンバスに反映する
    for (let lasso of allLassosRef.current) {
      if (lasso.length > 0) {
        tempCtx.beginPath();
        tempCtx.moveTo(lasso[0].x, lasso[0].y);
        for (let i = 1; i < lasso.length; i++) {
          tempCtx.lineTo(lasso[i].x, lasso[i].y);
        }
        tempCtx.closePath();
        tempCtx.fillStyle = '#fff';
        tempCtx.fill();
      }
    }

    // マスクをダウンロード
    const maskCanvas = document.createElement('canvas')
    maskCanvas.width = tempCanvas.width
    maskCanvas.height = tempCanvas.height
    const maskCtx = maskCanvas.getContext('2d')
    maskCtx.drawImage(tempCanvas, 0, 0) // 一時キャンバスの内容をマスクキャンバスに描画
    return maskCanvas.toDataURL()
  };

  const handleMaskOutput = () => {
    const link = document.createElement('a')
    link.download = 'mask.png'
    link.href = maskToBase64()
    link.click()
    link.remove()
  };

  const getMousePos = e => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    };
  };

  const drawLasso = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.putImageData(originalImageRef.current, 0, 0);

    if(lassoPointsRef.current.length > 0){
      ctx.beginPath();
      ctx.moveTo(lassoPointsRef.current[0].x, lassoPointsRef.current[0].y);

      for (let i = 1; i < lassoPointsRef.current.length; i++) {
        ctx.lineTo(lassoPointsRef.current[i].x, lassoPointsRef.current[i].y);
      }

      ctx.closePath();
      ctx.lineWidth = 2;
      ctx.strokeStyle = 'rgba(0, 0, 255, 0.5)';
      ctx.stroke();
    }
  };

  const applyWhiteFill = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    if (lassoPointsRef.current.length < 3) return;

    const path = new Path2D();
    path.moveTo(lassoPointsRef.current[0].x, lassoPointsRef.current[0].y);

    for (let i = 1; i < lassoPointsRef.current.length; i++) {
      path.lineTo(lassoPointsRef.current[i].x, lassoPointsRef.current[i].y);
    }

    path.closePath();

    // 新しいパスを使用してクリッピング領域を再設定
    ctx.save(); // クリッピング領域を保存
    ctx.clip(path);

    // 白で塗りつぶす
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // 元の画像データを更新
    originalImageRef.current = ctx.getImageData(0, 0, canvas.width, canvas.height);

    // 操作履歴に追加
    addToHistory();

    // クリッピングをリセット
    ctx.restore();
  };

  const addToHistory = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    // 操作履歴に現在の画像データを追加
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    historyRef.current = historyRef.current.slice(0, historyIndexRef.current + 1); // 現在位置以降の履歴を削除
    historyRef.current.push(imageData);
    historyIndexRef.current = historyRef.current.length - 1;

    // 選択範囲の履歴を更新
    allLassosRef.current = allLassosRef.current.slice(0, historyIndexRef.current);
    allLassosRef.current.push([...lassoPointsRef.current]);

    // 選択範囲の履歴も更新
    allLassosHistoryRef.current = allLassosHistoryRef.current.slice(0, historyIndexRef.current);
    allLassosHistoryRef.current.push([...allLassosRef.current]);
  };

  const undo = () => {
    if (historyIndexRef.current > 0) {
      historyIndexRef.current--;
      if (allLassosHistoryRef.current[historyIndexRef.current]) {
        restoreImage();
        // 選択範囲も更新
        allLassosRef.current = allLassosHistoryRef.current[historyIndexRef.current];
        // 選択範囲も更新
        lassoPointsRef.current = allLassosRef.current[historyIndexRef.current];
        drawLasso();
      }
    }
  };
  
  const redo = () => {
    if (historyIndexRef.current < historyRef.current.length - 1) {
      historyIndexRef.current++;
      //if (allLassosRef.current[historyIndexRef.current]) {
        restoreImage();
        // 選択範囲も更新
        allLassosRef.current = allLassosHistoryRef.current[historyIndexRef.current];
        // 選択範囲も更新
        lassoPointsRef.current = allLassosRef.current[historyIndexRef.current];
        drawLasso();
      //}
    }
  };

  const restoreImage = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const imageData = historyRef.current[historyIndexRef.current];
    ctx.putImageData(imageData, 0, 0);

    // 元の画像データを更新
    originalImageRef.current = ctx.getImageData(0, 0, canvas.width, canvas.height);
  };

  return (
    <div className='d-inline'>
      {originalImageRef.current === null ? 
      <Button variant='contained' onClick={() => imageInputRef.current.click()} className='m-1'><RIcon.FaImage />&nbsp;画像を選択</Button> 
      : (<>
      <IconButton onClick={reset}><CloseIcon /></IconButton>
      <IconButton onClick={undo}><RIcon.FaUndo /></IconButton>
      <IconButton onClick={redo}><RIcon.FaRedo /></IconButton>
      <Tooltip title="マスク画像をダウンロード">
        <IconButton onClick={handleMaskOutput} disabled={lassoPointsRef.current.length === 0}><RIcon.FaDownload /></IconButton>
      </Tooltip>
      </>)}
      <input type="file" ref={imageInputRef} accept="image/*" onChange={handleImage} className='d-none' />
      <div style={{overflow:"auto",width:"100%",height:"100%",display:originalImageRef.current === null ? "none" : "block"}}>
        <canvas id="canvas" width={1} height={1} ref={canvasRef} onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp} onMouseLeave={handleMouseLeave}></canvas>
      </div>
    </div>
  );
}

export default Inpaint;
